import React from 'react';
import { ReactPortal } from '../../../utils/utility/react-portal';
import {
  CloseIcon,
  InfoCircleIcon,
  WarningIcon,
  CloseCircleIcon,
  CheckIcon,
} from '../../../content/svg-component';
import './toast.scss';
import { useState, useEffect } from 'react';
export const Toast = ({
  isOpen,
  onClose,
  state = 'success',
  position = 'bottom-left',
  message = 'booking.successpayment',
  direction,
}) => {
  const [showPortal, setShowPortal] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setShowPortal(true);
      setTimeout(() => {
        onClose();
        destroyPortal();
      }, 4000);
    }
  }, [isOpen]);

  const destroyPortal = (sec = 1) => {
    setTimeout(() => {
      setShowPortal(false);
    }, sec * 1000);
  };

  // satus obj for color of text and shadow box
  const status = {
    success: 'success',
    info: 'info',
    warning: 'warning',
    danger: 'danger',
  };
  // icons obj for usage correct icon
  const icons = {
    success: <CheckIcon color="#00c853" />,
    info: <InfoCircleIcon color="#126eab" />,
    warning: <WarningIcon color="#ffc107" />,
    danger: <CloseCircleIcon color="#dc2633" size={20} />,
  };
  return (
    <>
      {showPortal ? (
        <ReactPortal wrapperId="react-portal-toast-container">
          <div
            className={`col-lg-3 col-md-5 col-8 px-0 position-fixed ${
              isOpen ? 'd-flex' : ''
            } flex-column shadow align-items-center border bg-white default-border-radius-xsmall animation-mode text-dark border-${
              status[state]
            } ${
              // this condition for animation classes (moving)
              isOpen
                ? `${position}-${direction}-position`
                : isOpen === false
                ? `${position}-${direction}`
                : ''
            }`}
            style={{ height: '4rem' }}
          >
            {/* this section for close alert toasting */}
            <div
              className="cursor-pointer position-absolute w-100 d-flex flex-row justify-content-end px-2"
              style={{ top: 8 }}
              onClick={() => {
                onClose();
                destroyPortal();
              }}
            >
              <CloseIcon color="#aaacaf" size={16} />
            </div>
            <div
              className={` d-flex flex-row justify-content-between align-items-center w-100 py-2 px-3`}
            >
              {/* here for text of massage & icon */}
              <div className="d-flex flex-row justify-content-start align-items-center">
                <div className="d-flex">{icons[state]}</div>
                <div className="px-2 d-flex flex-row justify-content-start align-items-center text-start">
                  {message}
                </div>
              </div>
            </div>
            {/* this section for line timer */}
            <div
              className={`${
                isOpen && 'line-timer'
              } bg-${state} position-absolute`}
              style={{ bottom: 4 }}
            ></div>
          </div>
        </ReactPortal>
      ) : (
        <></>
      )}
    </>
  );
};

Toast.propTypes = {};

export default Toast;
